import {FetchBaseQueryError} from '@reduxjs/toolkit/query';

import {createContext} from 'shared/web';

type Context = {
  onApiError: (error: FetchBaseQueryError) => void;
};

const [DataGridErrorContextProvider, useDataGridErrorContext] = createContext<Context>({
  strict: false,
  name: 'DatagridErrorProvider',
});

export {DataGridErrorContextProvider, useDataGridErrorContext};
